import React from 'react'
import { ApolloProvider as Provider } from '@apollo/client'
import { apolloClient } from 'lib/core/services/magento/client'

export const ApolloProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <Provider client={apolloClient}>
      {children}
    </Provider>
  )
}
